import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Center } from "@chakra-ui/react";
import { Audio, BallTriangle, Bars, Grid, Oval, Rings, ThreeDots, Triangle, } from "react-loader-spinner";
export const Loader = (props) => {
    const { color = "#11cdef", position = "fixed", type = "ThreeDots" } = props;
    const loaderObject = {
        Audio,
        BallTriangle,
        Bars,
        Grid,
        Oval,
        Rings,
        ThreeDots,
        Triangle,
    };
    const LoaderComponent = loaderObject[type];
    return (_jsx(Box, { position: position, top: "0px", bottom: "0px", left: "0px", right: "0px", zIndex: "9999", bg: "rgb(100 100 100 / 20%)", children: _jsx(Center, { minH: "100%", w: "100%", className: "loader-content", children: _jsx(LoaderComponent, { color: color, height: "100", width: "100" }) }) }));
};
//# sourceMappingURL=loader.js.map